import { insertNewLineAfterLastSlash } from './insertNewLineAfterLastSlash'

interface Option {
  value: string
  label: string
}

export const createSelectOptionsFromArray = (array: string[]): Option[] => {
  if (array.length === 0) {
    return []
  }

  return array.map(value => ({
    value,
    label: insertNewLineAfterLastSlash(value),
  }))
}
